import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrdersParams, TypeGetOrdersResponse } from '~/types/delivery-agency.types';

const useGetOrders = () => {
  const { runAsync } = useAsyncHandler();

  const getOrders = useAPI<TypeGetOrdersParams, TypeGetOrdersResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS,
    method: 'get',
  });

  const requestOrders = async (
    params: TypeGetOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetOrdersResponse) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getOrders({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOrders };
};

export default useGetOrders;
